import React, { useEffect, useState } from "react";
import UserAvater from "../Avatar/UserAvatar";

export default function SearchDropdown({data, parameter, link}) {

    const fillInTitle = (user) => {
        let holder = user.custom_field_values.filter(val => val.value.toLowerCase().includes(parameter.toLowerCase()))[0]

        let title = user.team_custom_fields.filter(field => field.id == holder.team_custom_field_id)

        return `${title[0].name}`
    }

    return (
        <div className="popup-search">
        {data.length > 0 && <div className="list-group-item splited-cu">
                    <div className='list-group-item-body'>
                        {data.slice(0, 7).map((user) => (
                            <div className='list-group-item-body-main d-flex pop-up-align mb-2' key={user.id}>
                                <div className="pop-up-content">
                                     <div className="avatar-sm d-inline-block mr-2">
                                        <UserAvater url={user.avatar_url} fallback={user.name} />
                                    </div>
                                    <div>
                                        <span>
                                            <strong>{user.name.replace(/\b\w/g, l => l.toUpperCase())}</strong>
                                        </span>
                                    </div>
                                </div>

                                <div className="pop-up-match">
                                        <a href={link + "/" + user.id} rel="noreferrer" className="mr-2" onClick={() => navigate(user.id)}>
                                            <i className="fa fa-external-link"></i>
                                        </a>
                                    {user.name.toLowerCase().includes(parameter.toLowerCase()) &&
                                        <span className="badge badge-sm badge-warning badge-pill mr-2">Name Match</span>
                                    }
                                    {!user.name.toLowerCase().includes(parameter.toLowerCase()) && String(user.username).toLowerCase().includes(parameter.toLowerCase()) &&
                                        <span className="badge badge-sm badge-warning badge-pill mr-2">Username Match</span>
                                    }
                                    {!user.name.toLowerCase().includes(parameter.toLowerCase()) && !String(user.username).toLowerCase().includes(parameter.toLowerCase()) && user.email.toLowerCase().includes(parameter.toLowerCase()) &&
                                        <span className="badge badge-sm badge-warning badge-pill mr-2">Email Match</span>
                                    }
                                    {!user.name.toLowerCase().includes(parameter.toLowerCase()) && !String(user.username).toLowerCase().includes(parameter.toLowerCase()) && !user.email.toLowerCase().includes(parameter.toLowerCase()) &&
                                    (user.additional_emails && user.additional_emails.length > 0 && user.additional_emails.some(email => 
                                        email.value.toLowerCase().includes(parameter.toLowerCase()))
                                    ) &&
                                        <span className="badge badge-sm badge-warning badge-pill mr-2">Additonal Email Match</span>
                                    }
                                    {!user.name.toLowerCase().includes(parameter.toLowerCase()) && !String(user.username).toLowerCase().includes(parameter.toLowerCase()) && !user.email.toLowerCase().includes(parameter.toLowerCase()) &&
                                     !(user.additional_emails && user.additional_emails.length > 0 && user.additional_emails.some(email => 
                                        email.value.toLowerCase().includes(parameter.toLowerCase()))
                                     ) &&
                                     user.custom_field_values.find(fields => {
                                        return fields.value.toLowerCase().includes(parameter.toLowerCase())
                                     }) &&
                                     <span className="badge badge-sm badge-warning badge-pill mr-2">
                                            {
                                                fillInTitle(user)
                                            }
                                    </span>
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
        </div>}
    </div>
    )
}
